<template>
  <section class="closefriend-hero ">
    <b @click="slideBar()" :class="showSlideBar ? 'screen-overlay show' : 'screen-overlay'"></b>
    <influencer-menu @menuClicked="slideBar()" :show-slide-bar="showSlideBar"></influencer-menu>
    <header-menu @slideMenu="slideBar()" :is-loading="busy && pageNumber === 0"></header-menu>

    <div class="container-fluid mt-3">
      <div class="row justify-content-center">
        <div class="col-12 px-2 px-md-4" style="max-width: 1200px;">
          <!-- Header -->
          <div class="d-flex flex-wrap align-items-center justify-content-between mb-4 mt-2 px-1 gap-2">
            <div>
              <h5 class="text-white font-weight-700 mb-0 font-size-20">Recent Transactions</h5>
              <span class="text-muted font-size-12">{{ customerTransactions.length }} transactions</span>
            </div>
          </div>

          <!-- Skeletons on initial load -->
          <div v-if="busy && customerTransactions.length === 0" class="row">
            <div class="col-12 col-md-6 col-lg-4 mb-3" v-for="i in 6" :key="'skeleton-' + i">
              <div class="custom-card-transparent p-4" style="height: 180px; display: flex; flex-direction: column; animation: pulse 1.5s infinite;">
                <div class="d-flex align-items-center justify-content-between mb-3">
                  <div style="height: 14px; width: 30px; background: rgba(255,255,255,0.08); border-radius: 4px;"></div>
                  <div style="height: 16px; width: 50px; background: rgba(255,255,255,0.08); border-radius: 6px;"></div>
                </div>
                <div style="height: 16px; width: 60%; background: rgba(255,255,255,0.06); border-radius: 4px; margin-bottom: 8px;"></div>
                <div style="height: 12px; width: 85%; background: rgba(255,255,255,0.03); border-radius: 4px;"></div>
                <div class="d-flex align-items-center justify-content-between mt-auto pt-3">
                  <div style="height: 12px; width: 70px; background: rgba(255,255,255,0.05); border-radius: 4px;"></div>
                  <div style="height: 12px; width: 80px; background: rgba(255,255,255,0.05); border-radius: 4px;"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- Empty state -->
          <div v-else-if="customerTransactions.length === 0 && !busy" class="text-center py-5">
            <div class="stella-empty-state-icon mb-3 mx-auto">
              <i class="fa fa-credit-card font-size-28" style="opacity: 0.4; color: #E53BB9;"></i>
            </div>
            <h5 class="text-white font-weight-500 mb-2" style="opacity: 0.7;">No transactions yet</h5>
            <p class="text-muted font-size-14 mb-0">Recent customer transactions will appear here.</p>
          </div>

          <div v-else
               v-infinite-scroll="loadMore"
               infinite-scroll-disabled="busy" infinite-scroll-distance="5"
               infinite-scroll-throttle-delay="1000"
               class="w-100 pb-5">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3" v-for="(customerTransaction, index) in customerTransactions" :key="index">
                <div class="custom-card-transparent" style="height: 100%; display: flex; flex-direction: column; cursor: default;">
                  <div class="stella-card-header d-flex align-items-center justify-content-between">
                    <span class="stella-card-index">#{{ index + 1 }}</span>
                    <span class="stella-card-price" style="font-weight: 800; color: #55EFC4;">${{ customerTransaction.amount }}</span>
                  </div>
                  <div class="stella-card-body flex-grow-1">
                    <h6 class="stella-card-title">{{ customerTransaction.name }}</h6>
                    <p class="stella-card-desc mt-2 mb-0" style="color: rgba(255,255,255,0.5); word-break: break-all;">{{ customerTransaction.transactionId }}</p>
                  </div>
                  <div class="stella-card-footer d-flex align-items-center justify-content-between mt-auto">
                    <span class="stella-card-status" style="font-weight: 500;" :style="{ color: getStatusColorHex(customerTransaction.status) }">
                      <span class="status-dot" :style="{ backgroundColor: getStatusColorHex(customerTransaction.status) }"></span> 
                      {{ camelCaseToSentence(customerTransaction.status) }}
                    </span>
                    <span class="font-size-12" style="color: rgba(255, 255, 255, 0.3);">
                      {{ customerTransaction.transactedAt | formatDateTime }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            
            <div v-if="busy && !isComplete" class="text-center w-100 py-3">
              <div class="spinner-border text-light" role="status" style="opacity: 0.5;">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import {mapGetters} from "vuex";
import {httpMixin} from "@/mixin/http-mixin";
import InfluencerHeader from "@/components/module/influencer/shared/InfluencerHeader";
import InfluencerMenu from "@/components/module/influencer/shared/InfluencerMenu";
import HeaderMenu from "@/components/module/influencer/shared/HeaderMenu";
import {camelCaseToSentence} from '@/common/Utils';
import {constructCustomerURL} from "@/common/baseURL-service";
import {newSubscriptionMixin} from "@/mixin/new-subscription-mixin";
import infiniteScroll from 'vue-infinite-scroll'
import titleMixin from "../../../../mixin/title-mixin";
import PwaActionBar from "@/components/module/influencer/shared/PwaActionBar";

export default {
  name: 'RecentTransactionMobile',
  title: 'Creator recent transaction',
  components: {HeaderMenu, InfluencerMenu, InfluencerHeader, PwaActionBar},
  mixins: [httpMixin, newSubscriptionMixin, titleMixin],
  data() {
    return {
      user: {},
      customerTransactions: [],
      showSlideBar: false,

      pageNumber: 0,
      noOfItems: 30,
      isComplete: false,
      busy: false
    }
  },
  created() {
    this.user = this.getUser();
    this.checkNewSubscription(this.user.id);
  },
  mounted() {
    this.loadMore();
  },
  computed: {
    copyLabel() {
      return this.copied ? 'Copied' : 'Copy';
    }
  },
  methods: {
    ...mapGetters(['getUser']),
    getStatusColorHex(status) {
      const s = status ? status.toLowerCase() : '';
      if (s === 'success' || s === 'completed') return '#55EFC4'; // Success (Emerald)
      if (s === 'pending') return '#80CBFE'; // Info (Blue)
      if (s === 'declined' || s === 'canceled' || s === 'failed') return '#FF4B81'; // Danger (Red)
      return '#B8B8B8'; // Default (Gray)
    },
    loadMore() {
      console.log('load-more');
      if (this.isComplete === true || this.busy) {
        return;
      }
      this.busy = true;
      let url = `payment/api/v1/influencers/${this.user.id}/page?pageNumber=${this.pageNumber}&numberOfItems=${this.noOfItems}`;
      this.getData(url, (page) => {
        if (!page.empty) {
          this.customerTransactions.push(...page.content);
          this.pageNumber += 1;
        }
        this.isComplete = page.last;
        this.busy = false;
        console.log('complete');
      })
    },
    constructCustomerURL,
    camelCaseToSentence,
    check() {
      this.showSlideBar = !this.showSlideBar;
    },
    slideBar() {
      this.showSlideBar = !this.showSlideBar;
    },
  },
  directives: {
    infiniteScroll
  }
}
;
</script>
<style scoped>
@media (max-width: 767px) {
  .media-query-class{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}

@media (min-width: 768px){
  .media-query-class{
    display: flex;
    flex-direction: row;
    justify-content:space-around;
  }
  .media-query-class2{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}
@media (min-width: 768px) and (max-width: 999px){
  .margin-class{
    margin-right: 50px;
  }
}




.stella-card-index {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 600;
}

.stella-card-price {
  font-size: 16px;
  font-weight: 700;
  color: #55EFC4;
}

.stella-card-title {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 4px;
}

.stella-card-desc {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.stella-card-status {
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.status-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
}

</style>
